import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";

import { AppStateService, getByExternalKey } from "@app/core";

export const AccessControlGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const appStateService = inject(AppStateService);

    try {
      await appStateService.waitUntilReady();
    } catch (error) {
      console.error("Failed waiting for app state readiness", error);
      router.navigate(['/landing']);
      return false;
    }
   
    const availableApps = appStateService.AppManagementState.apps();

    if (!availableApps) {
      console.warn("Application availability is not initialized before access control check");
      router.navigate(['/landing']);
      return false;
    }
    
    const routePath = route.routeConfig?.path || '';
    
    // Get the app access check function using external key lookup
    const currentApp = getByExternalKey(availableApps, routePath);

    
    // If no app check exists for this route, allow access by default
    if (!currentApp) {
        console.warn(`No access control defined for route: ${routePath}`);
        return true;
    }
    
    // Check if user has access
    const hasAccess = currentApp();
    
    if (hasAccess) {
        return true;
    }
    
    // Redirect to landing if no access
    console.log(`Access denied for route: ${routePath}`);
    router.navigate(['/landing']);
    return false;
};